import React, { ReactElement, useState, useEffect } from 'react'
import { orderBy } from 'lodash'
import { Cards } from '../../styled-components'
/* import { deleteCategory } from '../../../../api/Category' */
import { Part, TrainingGroup } from '../../../../types/training'
import PartAddEdit from '../add-edit-part'
/* import { Alert } from '../../../../constants/sweet-alert' */

import Card from '../../card'
import AdminTemplate from '../../../base-template'
import { Alert } from '../../../../constants/sweet-alert'
import { deletePart } from '../../../../api/part'
import DeleteModal from '../../../delete-modal'

interface PartCardsProps {
  trainingsGroup: TrainingGroup
  categoryId: string
}

const PartsCards = ({
  trainingsGroup,
  categoryId,
}: PartCardsProps): ReactElement => {
  const training = trainingsGroup.trainings[0]
  const category = training?.categories.find((c) => c.id === categoryId)
  const [allParts, setAllParts] = useState<Part[] | undefined>([])
  const [addPart, setAddPart] = useState<
    Omit<Part, 'questions' | 'status' | 'color' | 'text'> | undefined
  >(undefined)
  const [editPart, setEditPart] = useState<Part | undefined>(undefined)
  const [deletedPart, setDeletedPart] = useState<Part | undefined>(undefined)

  const [loadingDelete, setLoadingDelete] = useState<boolean>(false)

  useEffect(() => {
    setAllParts(category?.parts)
  }, [category])

  const removePart = () => {
    setLoadingDelete(true)
    deletePart(deletedPart?.id).then((result) => {
      if (result === 200) {
        const findPartIndex = allParts?.findIndex(
          (el) => el.id === deletedPart?.id
        )
        const oldParts = allParts
        oldParts?.splice(findPartIndex as number, 1)
        setAllParts(oldParts)
        setDeletedPart(undefined)
        Alert.fire({
          icon: 'success',
          title: `Deleted`,
        })
      } else {
        Alert.fire({
          icon: 'error',
          title: `Error`,
        })
      }
      setLoadingDelete(false)
    })
  }

  if (category) {
    return (
      <>
        {deletedPart ? (
          <DeleteModal
            onCancel={() => setDeletedPart(undefined)}
            title={deletedPart.title}
            onDelete={() => removePart()}
            loadingDelete={loadingDelete}
          />
        ) : null}
        <AdminTemplate
          onAddClick={() =>
            setAddPart({
              id: '',
              title: '',
              isWhat: '',
              quizType: null,
              placement: (category?.parts?.length || 0) + 1,
            })
          }
          navigation={[
            {
              title: trainingsGroup.title,
              link: `/trainings?type=${trainingsGroup.name}`,
            },
            {
              title: training.title,
              link: `/trainings?type=${trainingsGroup.name}&training_id=${training.id}`,
            },
            {
              title: category.title,
              link: `/trainings?type=${trainingsGroup.name}&training_id=${training.id}&category_id=${category.id}`,
            },
          ]}
          adminTemplate
        >
          {addPart ? (
            <PartAddEdit
              categoryId={category?.id}
              part={addPart}
              onClose={() => setAddPart(undefined)}
            />
          ) : editPart ? (
            <PartAddEdit
              onClose={() => setEditPart(undefined)}
              part={editPart}
            />
          ) : (
            <>
              <Cards>
                {orderBy(allParts, ['placement']).map((part: Part) => (
                  <Card
                    key={part.id}
                    element={part}
                    onClickEdit={(p) => setEditPart(p as unknown as Part)}
                    onDeleteClick={(p) => setDeletedPart(p as unknown as Part)}
                    link={`/trainings?type=${trainingsGroup.name}&training_id=${training?.id}&category_id=${category?.id}&part_id=${part?.id}`}
                  />
                ))}
              </Cards>
            </>
          )}
        </AdminTemplate>
      </>
    )
  }
  return <></>
}

export default PartsCards
